{
  "INTERNAL_ERROR": "Ocorreu um erro inesperado. Tente novamente.",
  "BAD_REQUEST": "Não foi possível processar a solicitação.",
  "UNAUTHORIZED": "Sua sessão não é válida. Entre novamente.",
  "FORBIDDEN": "Você não tem permissão para realizar esta ação.",
  "NOT_FOUND": "Não encontramos o que você procura.",
  "CONFLICT": "Esta ação conflita com dados existentes.",
  "TOO_MANY_REQUESTS": "Muitas tentativas. Aguarde um momento e tente novamente.",
  "SERVICE_UNAVAILABLE": "O serviço está indisponível no momento.",
  "VALIDATION_FAILED": "Verifique os dados enviados.",
  "VALIDATION_INVALID_FIELD": "O campo \"{{field}}\" é inválido.",
  "RECORD_ALREADY_EXISTS": "Já existe um registro com estes dados ({{fields}}).",
  "RECORD_NOT_FOUND": "Registro não encontrado.",
  "RELATED_RECORD_NOT_FOUND": "Registro relacionado não encontrado.",
  "RELATION_VIOLATION": "Esta ação violaria a relação entre registros.",
  "DATABASE_ERROR": "Erro ao acessar os dados. Tente novamente.",
  "DATABASE_VALIDATION_ERROR": "Os dados enviados são inválidos.",
  "TENANT_NOT_IDENTIFIED": "Área de membros não identificada. Verifique o endereço de acesso."
}
